export function isHtmlElement(element: unknown): element is HTMLElement {
  return element instanceof HTMLElement;
}

export function isEvent(event: unknown): event is Event {
  return event instanceof Event;
}
